import React, { useCallback, useState } from "react";
import { useBlocker, useNavigate } from "react-router-dom";

type props = {
    when?: boolean,
    children: any,
}

const RouteLeavingGuard: React.FC<props> = ({ when = true, children = null }) => {
    const navigate: any = useNavigate();

    const [isBlockModalOpen, setIsBlockModalOpen] = useState(false);
    const [nextLocation, setNextLocation] = useState();

    const onNavigation = useCallback((nextLocation: any) => {
        if (when && !isBlockModalOpen) {
            setNextLocation(nextLocation);
            setIsBlockModalOpen(true);
            return false;
        }

        return true;
    }, [when, isBlockModalOpen]);

    const onStay = useCallback(() => {
        setIsBlockModalOpen(false);
    }, []);

    const onLeave = useCallback(() => {
        setIsBlockModalOpen(false);
        navigate(nextLocation);
    }, [nextLocation, navigate]);

    useBlocker((blockerFunction: any) => {
        onNavigation(blockerFunction.nextLocation.pathname);

        return when && !isBlockModalOpen;
    });

    if (isBlockModalOpen) {
        return children(onStay, onLeave);
    }

    return <></>;
}

export default RouteLeavingGuard;